import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const NEW_TRANSACTION_TIME_DELTA = 1000 * 60 * 60; // 1 hour

export const PAGE_SIZE_OPTIONS = [5, 10, 20, 30, 40, 50];
